import { formatToCurrency } from '@betgames/bg-tools';

export const formatMultiplier = (multiplier: number) =>
    formatToCurrency(multiplier, 1, undefined, undefined, true);
